import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/coupon/page', data, {
    trim: true
  })
}
export function allList (data) {
  return request.post('/business/coupon/list', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/coupon/create', data)
}

export function updateStatus (data) {
  return request.post('/business/coupon/updateStatus', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/coupon/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/coupon/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/coupon/delete/batch', {
    params: {
      ids
    }
  })
}
